export const FORMATTING_PROMPT = `## Output Formatting

- Use markdown for structure (headings, bold, lists) but keep it readable
- Keep responses between 150-400 words unless the question demands more depth
- Use bullet points for lists of 3+ items
- Use bold for key terms and important phrases
- When citing knowledge articles or workflows, format as: **[Title](/path)** so they become clickable links
- Structure longer responses with clear sections using ### headings
- End every response with a follow-up question formatted on its own line

## Citation Format
When referencing platform content, use this format:
- Knowledge articles: **[Article Title](/knowledge/slug)**
- Workflows: **[Workflow Title](/workflows/slug)**
- Industries: **[Industry Name](/industries/slug)**
- Business Goals: **[Goal Title](/goals/slug)**

## Suggested Questions Format
At the end of your response, include exactly 2-3 follow-up questions the user might want to explore next. Format them as a simple list.`;
